import { Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from "@angular/router";
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { VerticalTabsComponent } from './components/vertical-tabs/vertical-tabs';
import { I18nService } from '../../shared/services/i18n.service';

@Component({
  selector: 'app-client-layout',
  imports: [
    CommonModule,
    RouterOutlet,
    VerticalTabsComponent,
    TranslateModule,
  ],
  templateUrl: './client-layout.html',
  styleUrl: './client-layout.scss',
  encapsulation: ViewEncapsulation.None
})
export class ClientLayout {
  private router = inject(Router);
  private translate = inject(TranslateService);
  private i18n = inject(I18nService);

  private url = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map((e: NavigationEnd) => e.urlAfterRedirects),
      startWith(this.router.url)
    )
  );

  pageTitle = computed(() => {
    const url = this.url() || '';
    if (url.includes('/client/settings')) return this.translate.instant('client.navigation.account_settings');
    if (url.includes('/client/orders/')) return this.translate.instant('client.orders_list.order_details');
    if (url.includes('/client/orders')) return this.translate.instant('client.navigation.my_orders');
    if (url.includes('/client/projects')) return this.translate.instant('client.navigation.my_projects');
    if (url.includes('/client/addresses')) return this.translate.instant('client.navigation.addresses');
    return '';
  });

  goBack(): void {
    this.router.navigate([this.i18n.generateUrlWithLang('')]);
  }
}
